/**
 * URL for the rewarders list.
 */
export const REWARDERS_LIST_URL =
  "https://raw.githubusercontent.com/QuarryProtocol/rewarder-list/master/data/rewarders.json";
